@if (!loading) {
  <section class="usage">
    <mulo-centered-block-layout>
      <h2 class="portal-section-title margin-bottom-md margin-top-md">
        {{'research.portal.repository.metrics' | translate}}
      </h2>
      <div (deferLoad)="showMetricsTotals = true"></div>
      @if (showMetricsTotals) {
        <esp-portal-metrics
          metric="totals"
          [show]="showMetricsTotals"
          [totalAssets]="totalAssets"
          >
        </esp-portal-metrics>
      }
    </mulo-centered-block-layout>
  </section>
}
